import * as Effects from 'redux-saga/effects';
import * as apiService from './service';
import { CONSTANTS, DATA_FETCH_STATUS, GRAPH_NAMES, GRAPH_TYPES } from './constants';
import { toast } from 'react-toastify';
import { isTabConfigValid } from './transformer';
import { JAVA_API_STATUS, SOMETHING_WRONG } from '../../utils/axios-interceptor';
import { takeEvery, call, put, takeLatest, select, race, take, delay } from 'redux-saga/effects';
import { refreshMsmeDelayGraph } from './compliancesBefe/msmeDelayGraphCache';
import { EPF_SETTLE_TIMEOUT_MS, MSME_DELAY_CARD_HEADER } from './compliancesBefe/constants';

function* fetchDashboardConfigData(action: any) {
    try {
        yield put({
            type: CONSTANTS.SET_IS_LOADING,
            payload: true,
        });
        const response = yield call(apiService.getDashboardConfig, action.payload);
        const responseData = response.data?.responseData;
        // const { mainConfig } = require('./config.json');
        const {
            data: { mainConfig },
        } = response;
        const { selectedTabId } = mainConfig;
        const selectedTabConfig = mainConfig?.tabConfigs?.[selectedTabId];
        const charts = selectedTabConfig?.chartPanel?.cards || [];
        switch (responseData && responseData.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                yield put({
                    type: CONSTANTS.GET_DASHBOARD_CONFIG_SUCCESS,
                    payload: mainConfig,
                });
                if (charts.length)
                    yield put({
                        type: CONSTANTS.INITIALIZE_GRAPH_CARDS,
                        payload: { charts: charts },
                    });
                if (selectedTabId) action?.payload?.setDefaultTab(selectedTabId);
                break;
            case JAVA_API_STATUS.ERROR:
            default:
                yield put({
                    type: CONSTANTS.SET_IS_LOADING,
                    payload: false,
                });
                yield put({
                    type: CONSTANTS.GET_DASHBOARD_CONFIG_FAILURE,
                });
                return toast.error(responseData?.responseMessage || SOMETHING_WRONG);
        }
    } catch (err: any) {
        yield put({
            type: CONSTANTS.SET_IS_LOADING,
            payload: false,
        });
        yield put({
            type: CONSTANTS.GET_DASHBOARD_CONFIG_FAILURE,
        });
        console.error(err?.message || 'Some error occoured');
    }
}

function* fetchHeadlineData(action: any) {
    try {
        const isPolling = action?.data?.isPolling;
        if (!isPolling)
            yield put({
                type: CONSTANTS.SET_IS_LOADING_HEADLINE,
                payload: true,
            });
        const response = yield call(apiService.getHeadlineData, action.payload);
        const tabData = response?.data?.tabData;
        const responseData = response.data?.responseData;

        switch (responseData && responseData.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                yield put({
                    type: CONSTANTS.GET_HEADLINE_DATA_SUCCESS,
                    payload: tabData || {},
                });
                break;
            case JAVA_API_STATUS.ERROR:
            default:
                yield put({
                    type: CONSTANTS.SET_IS_LOADING_HEADLINE,
                    payload: false,
                });
            // return toast.error(responseData?.responseMessage || SOMETHING_WRONG);
        }
    } catch (err: any) {
        yield put({
            type: CONSTANTS.SET_IS_LOADING_HEADLINE,
            payload: false,
        });
        console.error(err?.message || 'Some error occoured');
    }
}

function* fetchGraphData(action: any) {
    const graphName = action?.payload?.graphNames?.[0] || '--';
    const isPollingCall = action?.data?.isPollingCall;

    // The one config card served by polus BEFE instead of /insights/tab/data.
    if (graphName === GRAPH_NAMES.MSME_PAYMENT_DELAYS) {
        yield* fetchMsmeDelaysViaBefe(action);
        return;
    }

    try {
        if (!isPollingCall) {
            yield put({
                type: CONSTANTS.SET_IS_LOADING_GRAPH,
                payload: true,
                graphName: graphName,
            });
        }

        const response = yield call(apiService.getGraphData, action.payload);
        const responseData = response.data?.responseData;
        let graphs = response?.data?.graphs;

        switch (responseData && responseData.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                yield put({
                    type: CONSTANTS.GET_GRAPH_DATA_SUCCESS,
                    payload: {
                        graphNames: Object.keys(graphs || {}),
                        data: graphs,
                    },
                });
                break;
            case JAVA_API_STATUS.ERROR:
                yield put({
                    type: CONSTANTS.GET_GRAPH_DATA_ERROR,
                    payload: {
                        graphNames: [graphName],
                        data: graphs,
                    },
                });
                yield put({
                    type: CONSTANTS.SET_IS_LOADING_HEADLINE,
                    payload: false,
                });
                break;
            default:
                return;
        }
    } catch (err: any) {
        yield put({
            type: CONSTANTS.GET_GRAPH_DATA_ERROR,
            payload: {
                graphNames: [graphName],
            },
        });
        yield put({
            type: CONSTANTS.SET_IS_LOADING_HEADLINE,
            payload: false,
        });
        console.error(err?.message || 'Some error occoured');
    }
}

let aicaGradeD = {
    responseData: {
        responseCode: 20,
        responseMessage: 'Request Processed Successfully',
    },
    requestId: '2024040214:47:17',
    companyScore: 75,
    companyGrade: 'A',
    headers: [
        {
            displayName: 'Operating Score',
            tooltipDescription: 'Operating Score',
            headerScore: 30,
            metrics: [
                {
                    displayName: 'Revenue',
                    tooltipDescription: null,
                    metricScore: 20,
                },
                {
                    displayName: 'Revenue Growth',
                    tooltipDescription: null,
                    metricScore: 40,
                },
            ],
        },
        {
            displayName: 'Financial Score',
            tooltipDescription: 'Financial Score',
            headerScore: null,
            metrics: [],
        },
        {
            displayName: 'Management Score',
            tooltipDescription: 'Management Score',
            headerScore: null,
            metrics: [],
        },
        {
            displayName: 'Governance Score',
            tooltipDescription: 'Governance Score',
            headerScore: null,
            metrics: [],
        },
        {
            displayName: 'Sector Score',
            tooltipDescription: 'Sector Score',
            headerScore: null,
            metrics: [],
        },
    ],
};

function* fetchAicaGradeData(action: any) {
    try {
        yield put({
            type: CONSTANTS.SET_IS_LOADING_AICA_GRADE_DATA,
            payload: true,
        });
        const response = yield call(apiService.getAicaGradeDataService, action.payload);
        const aicaGradeData = response?.data;
        const responseData = response.data?.responseData;

        switch (responseData && responseData.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                yield put({
                    type: CONSTANTS.GET_AICA_GRADE_DATA_SUCCESS,
                    payload: aicaGradeData || {},
                });
                break;
            case JAVA_API_STATUS.ERROR:
            default:
                yield put({
                    type: CONSTANTS.SET_IS_LOADING_AICA_GRADE_DATA,
                    payload: false,
                });
        }
    } catch (err: any) {
        yield put({
            type: CONSTANTS.SET_IS_LOADING_AICA_GRADE_DATA,
            payload: false,
        });
        console.error(err?.message || 'Some error occoured');
    }
}

export default function* actionWatcher() {
    yield takeLatest(CONSTANTS.GET_DASHBOARD_CONFIG, fetchDashboardConfigData);
    yield takeLatest(CONSTANTS.GET_HEADLINE_DATA, fetchHeadlineData);
    yield takeEvery(CONSTANTS.GET_GRAPH_DATA, fetchGraphDataOnce, new Set<string>());
    yield takeLatest(CONSTANTS.GET_AICA_GRADE_DATA, fetchAicaGradeData);
}

const selectEpfComplianceChart = (state: any) => state?.dashboard?.dashboardReducer?.charts?.[GRAPH_NAMES.EPF_COMPLIANCE];

const isEpfSettledAction = (action: any) =>
    (action.type === CONSTANTS.GET_GRAPH_DATA_SUCCESS || action.type === CONSTANTS.GET_GRAPH_DATA_ERROR) &&
    !!action.payload?.graphNames?.includes(GRAPH_NAMES.EPF_COMPLIANCE);

/**
 * MSME rides the EPF ingestion, so it reports PROCESSING only while the EPF card does. An EPF card
 * that has not fetched yet (normal page load) is waited for — faking PROCESSING here would start
 * the headline poll — with a timeout because an out-of-view EPF card may never fetch.
 */
function* fetchMsmeDelaysViaBefe(action: any) {
    const graphName = GRAPH_NAMES.MSME_PAYMENT_DELAYS;
    if (action?.data?.isPollingCall) {
        const msmeChart = yield select(selectMsmePaymentDelaysChart);
        if (msmeChart?.metadata?.status !== DATA_FETCH_STATUS.PROCESSING) return;
    }
    try {
        if (!action?.data?.isPollingCall) {
            yield put({ type: CONSTANTS.SET_IS_LOADING_GRAPH, payload: true, graphName });
        }

        let epfChart = yield select(selectEpfComplianceChart);
        if (epfChart && !epfChart.isFetched) {
            yield race({ settled: take(isEpfSettledAction), timeout: delay(EPF_SETTLE_TIMEOUT_MS) });
            epfChart = yield select(selectEpfComplianceChart);
        }

        if (epfChart?.metadata?.status === DATA_FETCH_STATUS.PROCESSING) {
            yield put({
                type: CONSTANTS.GET_GRAPH_DATA_SUCCESS,
                payload: {
                    graphNames: [graphName],
                    data: {
                        [graphName]: {
                            metadata: {
                                cardType: GRAPH_TYPES.MSME_DELAY,
                                status: DATA_FETCH_STATUS.PROCESSING,
                                ...MSME_DELAY_CARD_HEADER,
                            },
                            plots: [],
                        },
                    },
                },
            });
            return;
        }

        const orgId = action?.payload?.orgId;
        if (!orgId) throw new Error('MSME payment delays need an orgId');
        const graph = yield call(refreshMsmeDelayGraph, orgId);
        if (!graph) throw new Error('MSME payment delays unavailable');
        yield put({
            type: CONSTANTS.GET_GRAPH_DATA_SUCCESS,
            payload: { graphNames: [graphName], data: { [graphName]: graph } },
        });
    } catch (err: any) {
        yield put({ type: CONSTANTS.GET_GRAPH_DATA_ERROR, payload: { graphNames: [graphName] } });
        console.error(err?.message || 'Some error occoured');
    }
}

/**
 * A card re-requested while its identical request is still in flight (tab re-entry re-initialises
 * the charts and the in-view observer can fire again) is dropped, so each visit sends one request.
 */
function* fetchGraphDataOnce(inFlightRequests: Set<string>, action: any) {
    const requestKey = JSON.stringify(action?.payload ?? {});
    if (inFlightRequests.has(requestKey)) return;
    inFlightRequests.add(requestKey);
    try {
        yield* fetchGraphData(action);
    } finally {
        inFlightRequests.delete(requestKey);
    }
}

const selectMsmePaymentDelaysChart = (state: any) => state?.dashboard?.dashboardReducer?.charts?.[GRAPH_NAMES.MSME_PAYMENT_DELAYS];
